import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import PlayIcon from '@material-ui/icons/PlayArrow'

const LowLatencyEncoderPreview = (props) => {
  const { encoder, autoPlay } = props
  let { classNames, styles } = props
  const [showPlayer, setShowPlayer] = useState(!!autoPlay)
  const src = encoder.lowLatencyPreview
  if (!classNames) classNames = ''
  if (!styles) styles = {}
  return (
    <div style={styles} className={`${!!classNames ? classNames : ''} low-latency-container`}>
      {showPlayer ? (
        <iframe
          allowFullScreen={true}
          style={{ width: '100%', height: '100%', border: 0, ...styles }}
          src={src}
        />
      ) : (
        <PlayButton onClick={() => setShowPlayer(true)} />
      )}
    </div>
  )
}

const PlayButton = (props) => {
  const { onClick } = props
  return (
    <div className='low-latency-preview-play-button-container'>
      <IconButton
        onClick={onClick}
        style={{ color: 'white', width: '100%', height: '100%', padding: 0, margin: 'auto' }}
      >
        <PlayIcon />
      </IconButton>
    </div>
  )
}

export default LowLatencyEncoderPreview
